module.exports = __webpack_public_path__ + "img/ico_x.bf8a883f.svg";